module.exports = __webpack_public_path__ + "img/Sprogreformation_Vaar_frelsers_gravlund.41a638b4.jpg";